import type { VersionSide } from '../fleet/ConfigVersionDiffView'

interface ActiveLike {
  readonly configVersion: number
  readonly configJson: Record<string, unknown>
  readonly pushedFrom: string
  readonly pushedAt: string | null
}
interface HistoryLike {
  readonly configVersion: number
  readonly configJson: Record<string, unknown>
  readonly pushedFrom: string
  readonly changedAt: string
  readonly changeReason: string | null
}

export function buildVersionEntries(active: ActiveLike | null, history: ReadonlyArray<HistoryLike>): VersionSide[] {
  const byVersion = new Map<number, VersionSide>()

  for (const h of history) {
    byVersion.set(h.configVersion, {
      version: h.configVersion,
      config: h.configJson,
      meta: { changedAt: h.changedAt, pushedFrom: h.pushedFrom, changeReason: h.changeReason },
    })
  }

  // History rows populate the map first and take precedence for a version that
  // appears in both: for a shared version the config body is identical (versions
  // are append-only/immutable), and the history row's meta is richer (it carries
  // changeReason, which the active row lacks). The active row only supplies its
  // version when history does not already contain it.
  if (active && !byVersion.has(active.configVersion)) {
    byVersion.set(active.configVersion, {
      version: active.configVersion,
      config: active.configJson,
      meta: { changedAt: active.pushedAt, pushedFrom: active.pushedFrom, changeReason: null },
    })
  }

  return [...byVersion.values()].sort((a, b) => b.version - a.version)
}
